module.exports = __webpack_public_path__ + "static/media/undraw_progress_data_4ebj.0b908be6.png";